import React from 'react'
import { connect } from 'react-redux'
import { jt, t } from 'ttag'
import { Modal, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { Link } from 'react-router-dom'

import militaryPerson from '@h2/assets/svg/icons/militaryPerson.svg'
import like from '@h2/assets/svg/icons/thumbsUpActive.svg'
import likeInactive from '@h2/assets/svg/icons/thumbsUpInactive.svg'
import dislike from '@h2/assets/svg/icons/thumbsDownActive.svg'
import disllikeInactive from '@h2/assets/svg/icons/thumbsDownInactive.svg'

import { loadMilitary, rateMilitary, selectLocalTab } from '../../actions/military'
import { removeForComparison, selectForComparison } from '../../actions/occupationProfile'
import ComparisonFooter from '../../components/ComparisonFooter'
import { openSigninDialog } from '../../actions/signinOrRegisterDialog'
import { toggleModal } from '../../actions/modals'
import PopupJournal from '../../components/journal/PopupJournal'
import Share from '../../components/social/Share'
import { useInitDispatch } from '../../util/hooks'

const MilitaryProfile = ({
  selectedProfile,
  selectedLocalTab,
  profileCache,
  onRateMilitary,
  localOpportunitiesLoading,
  selectedOccupations,
  modals,
  onToggleModal,
  jobZoneValues,
  onSelectLocalTab,
  onSelectOccupationForComparison,
  onRemoveOccupationForComparison,
  match
}) => {
  useInitDispatch(loadMilitary(match?.params.mocId), [match?.params.mocId])

  const profile = selectedProfile

  if (!profile) {
    return <span></span>
  }
  //console.log(profile, profileCache, selectedProfile)

  const aboutSection = () => {
    return (
      profile.description && (
        <div className="section" id="collegeinfo">
          <h3>
            <span>{t`About This Occupation`}</span>
          </h3>
          <p>{profile.description}</p>
          <p>
            <Link
              className="btn-h2more pull-right"
              style={{ fontSize: '1.2rem' }}
              to={profile.collegeSearchUrl}>
              {t`Find Colleges`}
            </Link>
          </p>
        </div>
      )
    )
  }
  const relatedOccupations = () => {
    return (
      <div className="section" id="collegeinfo">
        <h3>
          <span>{t`Civilian Equivalent Occupations`}</span>
        </h3>
        <table className="table tbl">
          <thead>
            <tr>
              <th>
                <OverlayTrigger
                  trigger={['hover', 'focus', 'click']}
                  placement="top"
                  overlay={
                    <Tooltip placement="bottom">{t`Select up to four boxes below to see a side-by-side comparison of the items`}</Tooltip>
                  }>
                  <i className="fal fa-eye" aria-hidden="true"></i>
                </OverlayTrigger>
                <span className="sr-only">{t`Comparison`}</span>
              </th>
              <th>{t`Occupation`}</th>
              <th>{t`Job Zone`}</th>
            </tr>
          </thead>
          <tbody>
            {(profile.occupations || []).map((m, i) => (
              <tr key={m.onetSoc} className={i % 2 == 0 ? 'even' : 'odd'}>
                <td>
                  <input
                    id={`check-${m.onetSoc}`}
                    type="checkbox"
                    {...(selectedOccupations.indexOf(m.onetSoc) >= 0
                      ? { checked: true }
                      : {})}
                    onChange={s => {
                      if (s.target.checked) {
                        s.target.checked = !!onSelectOccupationForComparison(m.onetSoc)
                      } else {
                        return onRemoveOccupationForComparison(m.onetSoc)
                      }
                    }}
                  />
                </td>
                <td>
                  <a href={m.url}>{m.title}</a>
                </td>
                <td>
                  <div>
                    {dynamicValues.newSiteLook ? (
                      <OverlayTrigger
                        trigger={['hover', 'focus', 'click']}
                        placement="right"
                        overlay={(
                          <Tooltip placement="bottom">
                            <div>
                              <b>{(jobZoneValues[m.jobZone] || {}).name}</b>
                              <br />
                              {(jobZoneValues[m.jobZone] || {}).description}
                            </div>
                          </Tooltip>
                        )}>
                        <div className="job-zone">{m.jobZone}</div>
                      </OverlayTrigger>
                    ) : (
                      <span className="fa-stack h2-table-stack">
                        <span className="h2-jobzone fa-stack-2x"></span>
                        <span className="fa-stack-1x h2-text-stack">{m.jobZone}</span>
                      </span>
                    )}
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }
  const similarMilitarySection = () => {
    return (
      <div className="section" id="collegeinfo">
        <h3>
          <span>{t`Related Military Occupations`}</span>
        </h3>
        <ul style={{ columnCount: '2' }}>
          {(profile.similarMoc || []).map(m => (
            <li>
              <Link to={m.url}>{m.title}</Link>
            </li>
          ))}
        </ul>
      </div>
    )
  }
  const youAndOcc = () => {
    const per = profile.personalization || {}
    const rating = per && per.hasOwnProperty('rating') ? per.rating : null
    const lastView = per.hasOwnProperty('lastView')
      ? new Date(per.lastView).toLocaleDateString()
      : ''

    return (
      <div>
        <div className=" youandocc">
          <h3>{t`You and This Program`}</h3>
          <div className="row">
            <div className="useractions col-xs-6">
              <div className="itemrating">
                <a
                  href="javascript:void(0)"
                  onClick={() => onRateMilitary(profile.id, 5)}>
                  <img
                    src={rating && rating > 3 ? like : likeInactive}
                    alt="Thumbs Up for Like Occupation Link"
                  />
                </a>
                <a
                  href="javascript:void(0)"
                  onClick={() => onRateMilitary(profile.id, 1)}>
                  <img
                    src={rating && rating < 3 ? dislike : disllikeInactive}
                    alt="Thumbs down for Dislike Occupation Link"
                  />
                </a>
                Your Rating
              </div>
            </div>
            <div className="useractions col-xs-6"></div>

            <div className="col-xs-offset-6 col-xs-3 history-item">
              <div className={`personalize-history`}>
                <h4
                  className={
                    ((per && per.militaryHistory) || []).length ? 'hasData' : ''
                  }>
                  {((per && per.militaryHistory) || []).length || 0}
                </h4>
                <span>{t`Resumes`}</span>
                <button
                  onClick={() =>
                    (window.location = `/jobtools/resume/addmilitary?type=military&moc=${profile.id}`)}>
                  {t`Add`}
                </button>
              </div>
            </div>
            <div className="col-xs-3 history-item">
              <div className={`personalize-history`}>
                <h4 className={((per && per.journals) || []).length ? 'hasData' : ''}>
                  {((per && per.journals) || []).length || 0}
                </h4>
                <span>{t`Journals`}</span>
                <button onClick={() => onToggleModal('journal', true)}>{t`Add`}</button>
              </div>
            </div>
          </div>
          {per.lastView && (
            <div className="lastView">{jt`You last viewed this on ${lastView}`}</div>
          )}
        </div>
      </div>
    )
  }

  return (
    <div id="profileinfocontainer">
      <div className="container">
        <div className="">
          <div className="headerBox row military">
            <div className="title-section col-sm-5">
              <h3>{profile.title}</h3>
            </div>
            <div className="lmi-callout col-sm-5">
              <div className="row">
                <div className="col-sm-6">
                  <h4>{t`Branch of Service`}</h4>
                  <h5>{(profile.branchOfService || {}).name}</h5>
                </div>
                <div className="col-sm-6">
                  <h4>{t`Code`}</h4>
                  <h5>{profile.moc}</h5>
                </div>
              </div>
            </div>
            <div className="col-sm-2 action-container">
              <a className="btn no-style media" href="javascript:void(0)" disabled={true}>
                <div
                  className="thumb"
                  style={{
                    backgroundImage: `url(${militaryPerson})`
                  }}>
                </div>
              </a>
              <a
                className="btn share"
                href="javscript:void(0)"
                onClick={() => onToggleModal('share')}>
                <span className="sr-only">{t`Share`}</span>
              </a>
              <a className="btn print" href={profile.printUrl}>
                <span className="sr-only">{t`Print`}</span>
              </a>
              {/*<a className="btn" href="#"><i className="fal fa-flag"></i><span className="sr-only">Bookmark</span></a>*/}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-8">
            {aboutSection()}
            {similarMilitarySection()}
            {relatedOccupations()}
          </div>
          <div className="col-sm-4">{youAndOcc()}</div>
        </div>
      </div>
      <ComparisonFooter />
      <Modal
        bsSize="large"
        enforceFocus={false}
        show={modals && modals.selectedModal === 'journal'}
        onHide={() => onToggleModal(null)}>
        <Modal.Header closeButton>
          <h2>{t`Journal Entries`}</h2>
        </Modal.Header>
        <Modal.Body>
          {profile.personalization?.journals && (
            <PopupJournal
              journals={profile.personalization?.journals}
              objectType={profile.personalization?.journalType}
              objectId={profile.id}
              objectTitle={profile.title}
            />
          )}
        </Modal.Body>
      </Modal>
      <Modal
        bsSize="large"
        show={modals && modals.selectedModal === 'share'}
        onHide={() => onToggleModal(null)}>
        <Modal.Header closeButton>
          <h2>{t`Social`}</h2>
        </Modal.Header>
        <Modal.Body>{<Share />}</Modal.Body>
      </Modal>
    </div>
  )
}

export default connect(
  state => {
    return {
      ...state.military.profile,
      modals: state.modals.Military,
      jobZoneValues: state.jobZones.jobZoneValues,
      selectedOccupations: state.occupations.comparison.selectedOccupations
    }
  },
  dispatch => ({
    onRateMilitary: (cipCode, rating) => {
      if (dynamicValues.userProfile) {
        dispatch(rateMilitary(cipCode, rating))
      } else {
        dispatch(openSigninDialog('signIn'))
      }
    },
    onSelectLocalTab: (cipCode, t) => dispatch(selectLocalTab(cipCode, t)),
    onSelectOccupationForComparison: itm => {
      console.log(itm)
      dispatch(selectForComparison(itm))
    },
    onToggleModal: (modalName, requireLoggedIn) => {
      if (!!requireLoggedIn && !dynamicValues.userProfile) {
        dispatch(openSigninDialog('signIn'))
      } else {
        dispatch(toggleModal('Military')(modalName))
      }
    },
    onRemoveOccupationForComparison: itm => dispatch(removeForComparison(itm))
  })
)(MilitaryProfile)
